import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import router from '../router'
import axios from 'axios'
import swal from 'sweetalert'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    products : [],
    carts : []
  },
  mutations: {
    setProducts ( state , payload ){
      state.products = payload
    },
    setCarts ( state , payload){
      state.carts = payload
    }
  },
  actions: {
    register ( context , payload ){
      axios({
        url: 'https://bukapasar.herokuapp.com/register',
        method: 'post',
        data: payload
      })
        .then(({data}) => {
          console.log(data)
          router.push({name : 'Login'})
        })
        .catch(err => {
          swal({
            title : 'Email is registered'
          })
          console.log(err);
        })
    },
    login ( context , payload ){
      axios({
        url: 'https://bukapasar.herokuapp.com/login',
        method: 'post',
        data: payload
      })
        .then(({data})=> {
          localStorage.setItem('access_token',data.access_token)
          console.log(data)
          console.log(data.access_token);
          router.push({name: 'Home'})
          swal({
            title : 'Login Success'
          })
        })
        .catch(err => {
          console.log(err)
          swal({
            title : 'Email or Password incorrect'
          })
        })
    },
    fetchProducts ( context ){
      axios({
        url: 'https://bukapasar.herokuapp.com/home',
        method: 'get',
      })
      .then(({data}) => {
        context.commit('setProducts',data)
      })
      .catch(err => {
        console.log(err);
      })
    },
    fetchCarts ( context , payload ){
      axios({
        url: 'https://bukapasar.herokuapp.com/carts',
        method: 'get',
        headers : {
          access_token : localStorage.access_token
        }
      })
      .then(({data}) => {
        context.commit('setCarts',data)
      })
      .catch(err => {
        console.log(err);
      })
    },
    deleteCart ( context , id ){
      axios({
        url : `https://bukapasar.herokuapp.com/carts/${id}`,
        method : 'delete',
        headers : {
          access_token : localStorage.access_token
        }
      })
      .then(({data})=> {
        context.dispatch('fetchCarts')
      })
      .catch(err => {
        console.log(err);
      })
    }
    ,
    addCart ( context ,productId ){
      axios({
        url : `https://bukapasar.herokuapp.com/carts/${productId}`,
        method : 'post',
        headers : {
          access_token : localStorage.access_token
        }
      })
          .then(({data})=> {
            console.log(data);
            console.log('success');
          })
          .catch(err => {
            console.log(err);
          })
    }
  }
})
